<template>
  <div id="reportTable">
    <div class="title">
      <h3 style="display: none;">{{ data.full_name }} {{ title }}</h3>
    </div>

    <!-- Reports Table -->
    <!-- <p id="demo"> {{text}}</p> -->
    <table>
      <thead v-bind:style="{ 'background-color':  reportColour}" >
        <tr>
          <template>
            <th>
              Pos
            </th>
            <th v-if="home === false">
              Country
            </th>
            <th style="padding-left:0px;">
              Name
            </th>
            <th class="" v-if="data.show_winnings == 'B'">
              <span v-show="data.show_winnings == 'Y'">Winnings</span>
              <span v-show="data.show_winnings == 'P'">
                <span v-hide="data.show_points_name.length > 0">Points</span>
                <span v-show="data.show_points_name.length > 0">{{ data.show_points_name }}</span>
              </span>
            </th>
            <th class="" v-else-if="data.show_winnings == 'P' && data.result.result_entry[0].winnings">
              <span>Points</span>
            </th>
            <th class="" v-else-if="data.show_winnings == 'Y'">
              <span>Score</span>
            </th>
            <!-- <th v-elseif="data.show_winnings == 'B'" class="hidden-xs">Winnings</th> -->
            <template>
              <th class="parTxt">
                Par
              </th>
              <th v-if="home === false">
                Score
              </th>
              <th v-for="(i, roundIt) in range(1, roundsPlayed)" :key="roundIt" v-show="home === false" >
                <span v-if="data.rounds_played  > 1 ">R{{ i }}</span>
                <span else ></span>
              </th>
              <th v-if="config.VUE_APP_PLAYER_ICON === 'Y'"></th>
            </template>
          </template>
        </tr>
      </thead>
      <tbody>

      <template>
        <template v-for="(tabledata, index) in Eds">
          <tr @click.stop="rowClicked(index)" :key="index" :class="{scoreOnlyCheckOrination: mobWidget == 'Y'}">
              <td class="cut" colspan="11" v-if="tabledata.pos == 'EOQ'" style="text-align:center">
                {{ tabledata.pos }}
              </td>
              <td
                class="posnum"
                v-else-if="
                  index !== 0 &&
                    (tabledata.tied !== '=' ||
                      Eds[index - 1].pos !== tabledata.pos)
                "
              >
                <span>
                  {{ tabledata.pos }}
                </span>
              </td>
              <td class="posnum" v-else-if="index === 0">
                <span>
                  {{ tabledata.pos }}
                </span>
              </td>
              <td v-else class="noPos"><span>.</span></td>
              <td class="mobHide" v-if="tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ' && home === false">
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <img
                    class="flag"
                    :src="
                      (config.VUE_APP_FLAG_URL + tabledata.nationality)
                        | lowercase
                    "
                  />
                  {{ tabledata.represents }}
                </span>
              </td>
              <td
                v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                @click="playerCard"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                }"
                id="footer-float"
              >
                  {{ tabledata.playing_name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                  <!-- <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="titleistLogo" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                  ></span> -->
              </td>
              <td class="posDownWinnings" v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ' && data.result.result_entry[0].winnings">
                <template v-if="data.show_winnings == 'P'">
                  {{ tabledata.winnings }}
                </template>
                <template v-else-if="data.show_winnings == 'Y' && data.full_name.includes('Qualifier') || data.short_name.includes('Qualifying')">
                  <span v-if="tabledata.vspar < 0 && roundsPlayed > 0 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'" class="up posDown">
                    {{ tabledata.score }}
                  </span>
                  <span
                    v-else-if="tabledata.vspar > 0 && roundsPlayed > 0 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                    class="down posDown"
                  >
                    {{ tabledata.score }}
                  </span>
                  <span class="posDown" v-else-if="roundsPlayed > 0 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'">
                    {{ tabledata.score }}
                  </span>
                </template>
                <template v-else>
                   {{ tabledata.winnings }}
                </template>
              </td>
              <template v-if="match === 'N'">
                <td v-if="tabledata.vspar < 0 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'" class="up posDown">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.vspar > 0 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'" class="down posDown">
                  {{ tabledata.vspar }}
                </td>
                <td  class="posDown" v-else-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'">
                  {{ tabledata.vspar }}
                </td>
                <template v-if="home === false">
                <td v-if="tabledata.vspar < 0 && roundsPlayed > 1 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'" class="up posDown">
                  {{ tabledata.score }}
                </td>
                <td
                  v-else-if="tabledata.vspar > 0 && roundsPlayed > 1 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                  class="down posDown"
                >
                  {{ tabledata.score }}
                </td>
                <td class="posDown" v-else-if="roundsPlayed > 1 && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'">
                  {{ tabledata.score }}
                </td>
                </template>
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  v-show="home === false && tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up posDown"
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down posDown"
                    >{{ tabledata.score }} </span
                  >
                  <span class="posDown" v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span v-else-if="tabledata['vspar_R' + i] < 0" :class="up" class="posDown">{{
                    tabledata["score_R" + i]
                  }}</span>
                  <span
                    v-else-if="tabledata['vspar_R' + i] > 0"
                    :class="down"
                    class="posDown"
                    >{{ tabledata["score_R" + i] }} </span
                  >
                  <span class="posDown" v-else>{{ tabledata["score_R" + i] }}</span>
                </td>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    tabledata.pos !== 'EOF' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
              >
                <a :href="'/playerprofile/' + tabledata.playerno">
                  <font-awesome-icon
                    style="color:#f2af15!important;"
                    id="user"
                    class="icon"
                    :icon="['fa', 'user']"
                  />
                </a>
              </td>
          </tr>
        </template>
      </template>

      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import ads from '@/js/ads.js'

export default {
  name: "results",
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "match",
    "show",
    "multi_tourns"
  ],
  components: { 

  },
  data() {
    return {
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: [],
      win: "win",
      ads:ads,
      reportColour: process.env.VUE_APP_REPORT_MAIN_COLOUR,
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      text: ''
    };
  },
  methods: {
    // isMobile() {
    //   if (screen.width <= 768) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    titleFunction: function() {
      var div = document.getElementById('footer-float');
      var links = div.getElementsByTagName('td');
      for(var i = 0; i < links.length; i++) {
        links[i].title = '';
      }      
    },
    myFunction: function() {
      
      // let w = window.outerWidth;
      // let txt = "Window size: width=" + w + ", height=" + h;
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
      console.log("this.text")
      console.log(this.text)
    },
    getResults: function(x, y) {
      const rowLimit = (this.multi_tourns == 'Y' || this.show == true) ? x : y;
      const reportData = [];

      let rowCount = 0;

      for (const i of this.data.result.result_entry) {
        if (rowCount >= rowLimit)
          break;

        if (i.pos != 'EOQ' && i.pos != 'cat') {
          reportData.push(i);
          rowCount++;
        }
      }

      return reportData;
    },
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.tablePick === "Score" && this.clickedRow !== index)
        this.clickedRow = index;
      else this.clickedRow = -1;
    },
    playerCard: function(event) {
      var cardID = event.target.getAttribute("title");
      return (
        (this.cardID = cardID),
        axios
          .get(
            process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.code +
              "-cards-" +
              this.cardID +
              ".json?randomadd=" +
              new Date().getTime()
          )
          .then((response) => (this.playerCardData = response.data))
      );
    },
  },
  computed: {
    tablePick: function(picked) {
      if (this.title.includes("Tournament")) picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        this.title.includes("Scores") ||
        this.title.includes("Scoreboard")
      )
        picked = "Score";
      else if (this.title.includes("Live")) picked = "Live";
      else if (
        this.title.includes("Final") ||
        this.title.includes("Statistics")
      )
        picked = "Final";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    pftroundsPlayed() {
      return parseInt(this.data.pft_round);
    },
    Eds(reportData) {
      const windowWidth = window.innerHeight;
      console.log("windowWidth")
      console.log(windowWidth)
      if (this.home === false) {
        if (this.title.includes("Tournament"))
          reportData = this.data.entries.entries_entry;
        else if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry;
        else if (
          (this.title.includes("Scores") && this.team === "N") ||
          (this.title.includes("Scoreboard") && this.team === "N") ||
          (this.title.includes("Live") && this.team === "N")
        )
          reportData = this.data.scores.scores_entry;
        else if (
          (this.title.includes("Scores") && this.team === "Y") ||
          (this.title.includes("Scoreboard") && this.team === "Y") ||
          (this.title.includes("Live") && this.team === "Y")
        )
          reportData = this.data.team_scores.team_scores_entry;
        else if (
          this.title.includes("Final") ||
          this.title.includes("Statistics")
        ) {
          reportData = this.data.result.result_entry;
          // var setOne = allData.slice(0, 5);
          // var setTwo = allData.slice(5, 25);
          // var setThree = allData.slice(25);
          // var addOne = this.ads[0];
          // var addTwo = "Test Two";
          // let comone = setOne.concat(addOne);
          // let comtwo = setTwo.concat(addTwo);
          // let comthree = comone.concat(comtwo);
          // reportData = comthree.concat(setThree);
        }
        return reportData;
     } else {
        if (process.env.VUE_APP_MOB_WIDGET == 'Y') {
            if (this.title === "Tournament Entries")
              reportData = this.data.entries.entries_entry.slice(0, 5);
            else if (this.title.includes("Draw"))
              reportData = this.data.draw.draw_entry.slice(0, 10);
            else if (
              this.title.includes("Scores") ||
              this.title.includes("Scoreboard")
            )
              reportData = this.data.scores.scores_entry.slice(0, 6);
            else if (
              this.title.includes("Final") ||
              this.title.includes("Statistics")
            )
              reportData = this.data.result.result_entry.slice(0, 5);
            return reportData;
        } else {
            if (this.title === "Tournament Entries")
              if (windowWidth < '400' && windowWidth > '311') {
                console.log('400 - 311')
                reportData = this.data.entries.entries_entry.slice(0, 7); 
              } else if(windowWidth < '311') {
                console.log(' < 400')
                reportData = this.data.entries.entries_entry.slice(0, 5);
              } else {
                reportData = this.data.entries.entries_entry.slice(0, 10);
              }
            else if (this.title.includes("Draw"))
              reportData = this.data.draw.draw_entry.slice(0, 10);
            else if (
              this.title.includes("Scores") ||
              this.title.includes("Scoreboard")
            )
              if (windowWidth < '400' && windowWidth > '311') {
                console.log('400 - 311')
                reportData = this.data.scores.scores_entry.slice(0, 7); 
              } else if(windowWidth < '311') {
                console.log(' < 400')
                reportData = this.data.scores.scores_entry.slice(0, 5);
              } else {
                reportData = this.data.scores.scores_entry.slice(0, 10);
              }
            else if (
              this.title.includes("Final") ||
              this.title.includes("Statistics")
            )
              if  (this.text == 1400 || this.text > 1401) {
                reportData = this.getResults(7, 7);
              } else if(this.text < 1400  && this.text > 1199) {
                reportData = this.getResults(8, 9);
              } else if (this.text < 1198  && this.text > 1022){
                reportData = this.getResults(5, 6);
              } else if (this.text < 990){
                reportData = this.getResults(6, 6);
              }
            return reportData;
          }
        }
    },
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
      console.log(newValue);
      window.addEventListener('resize', this.Eds);
      window.addEventListener('resize', this.windowWidth);
      console.log("--" + this.windowWidth)
    },
    immediate: true,
    deep: true,
  },
  created() {
    this.myFunction();
    this.titleFunction();
    window.addEventListener('resize', this.myFunction);
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
  },
};
</script>

<style scoped>
@media (orientation: landscape) {
  ::v-deep .scoreOnlyCheckOrination:nth-child(5) {
    display: none;
  }
  ::v-deep .scoreOnlyCheckOrination:nth-child(4) {
    display: none;
  }
}
th.parTxt {
  text-align: center;
}
img.titleistLogo {
  width: 35px;
}
tr {
  border-bottom: 1px solid #00000033!important;
}
a.nameLink{
  color: #000 !important;
}
a.nameLink > span > img{
  width: 30px;
  margin-left: 10px;
}
.catSection {
  padding-top: 16px!important;
  text-align: center!important;
}
.homeEntriesPos {
  margin-top: 8px!important;
}
.homeEntriesStatus {
  vertical-align: middle;
}
a.homeEntriesName {
  margin-top: 0px!important;
}
span.multiCourseSpanTeam {
  margin-top: 10px;
  float: right;
}
span.multiCourseSpan {
  float: right;
  margin-top: -17px;
}
span.multiCourseSpanTeam.B {
  color: #333333;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.Y {
  color: #d8db22;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.C {
  color: #1E90FF;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.R {
  color: #BB0000;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.G {
  color: #3c9933;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.O {
  color: #e07020;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpan.B {
  color: #333333;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.Y {
  color: #d8db22;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.C {
  color: #1E90FF;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.R {
  color: #BB0000;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.G {
  color: #3c9933;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.O {
  color: #e07020;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
.B {
  color: #333333;
}
.Y {
  color: #d8db22;
}
.C {
  color: #1E90FF;
}
.R {
  color: #BB0000;
}
.G {
  color: #3c9933;
}
.O {
  color: #e07020;
}
td.posDown {
  position: relative;
  padding-top: 5px;
  text-align: center;
}
td.posDownWinnings {
  /* margin-top: 10px; */
  /* position: revert; */
  text-align: right;
}
span.posDown {
  position: relative;
  top: 0px;
  left: -14px;
}
td.ParBlack{
  position: relative;
  padding-top: 20px;
}
span.ParBlack{
  position: relative;
  top: 4px;
}
::v-deep span.down.posDown {
  position: relative;
  top: 4px;
}
td.down.posDown {
  position: relative;
  /* padding-top: 20px; */
  top: -8px;
}
::v-deep span.up.posDown {
  position: relative;
  top: 0px!important;
  left: -14px;
}
::v-deep span.down.posDown {
  position: relative;
  top: 0px!important;
  left: -14px;
}
td.up.posDown {
  position: relative;
  padding-top: 4px;
}
.scorePos {
  margin-left: 0px!important;
}
span.FlagScores {
  margin-top: 6px;
  display: block;
}
::v-deep button#__BVID__32__BV_toggle_ {
  line-height: 35px;
  padding-bottom: 0;
  height: 40px;
}
td.drawName > a {
  margin-top: 1px;
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
  margin-top: 0px!important;
  padding-top: 7px!important;
  padding-bottom: 22px!important;
}
.title {
  text-align: center;
  background-color: #00433e;
  color: white;
}
.title > h3 {
  padding-top: 8px;
  margin-bottom: 0px;
  font-size: 24px;
}
.title > p {
  font-size: 16px !important;
  margin-bottom: 0;
}
th {
  position: sticky;
  top: 0;
  /* background-color: #00433e; */
  vertical-align: bottom;
  border-bottom: 0px solid #ddd;
  font-weight: bold;
  color: white;
  font-size: 13px;
  text-transform: capitalize;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  /* background: #00433e; */
  color: #ffffff !important;
  text-align: left;
  padding-bottom: 8px;
  padding-top: 8px;
  z-index: 2;
}

.win {
  background-color: #02b2dd !important;
  color: black;
}
.catD {
  color: #7d7d7d;
  font-weight: 300;
}
.drawName {
  font-size: 14px !important;
}
table {
  width: 100%;
}

thead > tr {
  color: white;
}
td:first-child {
  text-align: left;
}
th:first-child {
  text-align: left;
  padding-left: 5px;
}
th:nth-child(3) {
  text-align: right;
  padding-right: 10px;
}
td:nth-child(3) {
  text-align: right;
}
.odd {
  background-color: white !important;
}
.even {
  background-color: #dfe1e6 !important;
}
tr:nth-child(even) {
  background-color: #fff;
}
td.posnum {
  /* padding: 5px;
  padding-top: 4px;
  padding-bottom: 4px; */
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1px;
  /* margin-top: 3px; */
  margin-bottom: 0px;
  color: black;
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
}
::v-deep td > a {
  /* margin-top: 6px; */
  display: block;
}
td {
  /* padding: 12px; */
  /* padding: 8px; */
  padding: 4px;
  line-height: 1.42857143;
  vertical-align: middle;
  border-top: 0px solid #ddd;
  border-right: none !important;
  /* cursor: pointer; */
  text-align: left;
  padding-left: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

td.posnum > span {
  padding: 5px;
  display: block;
  max-width: 58px;
}
.noPos > span {
  color: transparent;
  padding: 5px;
  display: block;
  max-width: 58px;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
.up {
  color: #a52a2a;
}
.down {
  color: #1e90ff;
}
.text-down {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: glow-red 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 10px rgba(255, 82, 82, 0.7);
  }
}

.text-up {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: glow-green 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-green {
  to {
    text-shadow: 0 0 10px rgba(51, 217, 178, 0.7);
  }
}
.cut {
  padding-top: 6px !important;
  padding-right: 6px !important;
  padding-bottom: 6px !important;
  font-size: 14px;
  vertical-align: middle;
  padding-left: 8px !important;
  background: #aa0003;
  color: white;
}
::v-deep a:hover{
      color: #00b588!important;
      text-decoration: none;
}
@media only screen and (max-width: 768px) {
  ::v-deep td {
    /* font-size: 12px !important; */
    position: revert!important;
  }
  th {
    font-size: 13px;
  }
  .mobHide {
    display: none;
  }
  #reportCard {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media only screen and (max-width: 400px) {
  ::v-deep td {
    padding: 0.1vw!important;
  }
}
</style>